export default [
  { name: 'Al Sharqia', code: 'SHR' },
  { name: 'Alexandria', code: 'ALX' },
  { name: 'Aswan', code: 'ASN' },
  { name: 'Asyut', code: 'AST' },
  { name: 'Beheira', code: 'BH' },
  { name: 'Beni Suef', code: 'BNS' },
  { name: 'Cairo', code: 'C' },
  { name: 'Dakahlia', code: 'DK' },
  { name: 'Damietta', code: 'DT' },
  { name: 'Faiyum', code: 'FYM' },
  { name: 'Gharbia', code: 'GH' },
  { name: 'Giza', code: 'GZ' },
  { name: 'Helwan', code: 'HU' },
  { name: 'Ismailia', code: 'IS' },
  { name: 'Kafr el-Sheikh', code: 'KFS' },
  { name: 'Luxor', code: 'LX' },
  { name: 'Matrouh', code: 'MT' },
  { name: 'Minya', code: 'MN' },
  { name: 'Monufia', code: 'MNF' },
  { name: 'New Valley', code: 'WAD' },
  { name: 'North Sinai', code: 'SIN' },
  { name: 'Port Said', code: 'PTS' },
  { name: 'Qalyubia', code: 'KB' },
  { name: 'Qena', code: 'KN' },
  { name: 'Red Sea', code: 'BA' },
  { name: 'Sohag', code: 'SHG' },
  { name: 'South Sinai', code: 'JS' },
  { name: 'Suez', code: 'SUZ' }
];
